import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Arrows from '../icons/arrows.svg'

const Container = styled.a`
display:inline-block;
background-color:var(--tmain);
border: 2px solid var(--tmain);
border-radius:8px;
color:var(--twhite);
padding:0px 10px 2px 10px;
text-decoration:none;
transition: 0.2s ease;

font-family:Montserrat;
font-weight:400;
font-style:italic;
font-size:16px;

&::before {
    content:"»";
    color:var(--twhite);
    font-size:22px;
    margin-right:8px;
    transition: 0.2s ease;
}

&:hover{
    color:var(--tmain);
    background-color:var(--twhite);
    cursor:pointer;

    &::before {
        color:var(--tmain);
    }
}

@media(min-width:993px){
    &::before {
        content:"»";
        color:var(--twhite);
        font-size:20px;
        margin-right:10px;
    }

    padding:0px 10px 2px 10px;
    font-size:16px;
}
`

const RedButton = ({href, PropOnClick, children}) => (
    <Container href={href} onClick={PropOnClick}>{children}</Container>
);

RedButton.propTypes = {
};

export default RedButton;